/**
 * Analytics Page
 * View visitor tracking analytics and data
 */

import React from 'react';
import { AnalyticsDashboard } from '../components/analytics-dashboard';

export default function Analytics() {
  return (
    <div className="container mx-auto p-6">
      <AnalyticsDashboard />
    </div>
  );
}